import { storeToRefs } from 'pinia'
import { useOrganizationsStore } from '~/store/organizations'
import type { OrganizationRoles } from '~/constants/organizations'
import { isUserGranted } from '~/utils/user'
import useUser from '~/composables/useUser'

// TODO: Use store values
export const hasOrganizations = () => {
  const { claims } = useUser()
  const organizations = claims.value?.organizations ?? []
  return organizations.length >= 1
}

export const isUserGrantedInOrganization = (
  minimumRole: OrganizationRoles,
  userOrganizationRole?: OrganizationRoles,
) => {
  if (userOrganizationRole) {
    return isUserGranted(userOrganizationRole, minimumRole)
  }
  else {
    // TODO: Update to not check the claims

    const organizationsStore = useOrganizationsStore()
    const { selectedOrganization } = storeToRefs(organizationsStore)
    const { claims } = useUser()

    // TODO: Fix false return on refresh due to null `selectedOrganization.value`
    if (!claims.value?.organizations || !selectedOrganization.value)
      return false

    const organizationClaims = claims.value?.organizations.find(
      (organization) => {
        const { id } = decodeAccessClaims(organization)
        return id === selectedOrganization.value?.id
      },
    )

    // Due to persisted state, it is empty
    if (!organizationClaims) return false

    const { role } = decodeAccessClaims(organizationClaims)
    return isUserGranted(Number(role), minimumRole)
  }
}
